import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import adminToolsService from "../../services/admin-tools.service";
import { setHeaderMenuData } from "../../actions/headerMenu/headerMenu";
import RingBuilder from "../../assets/images/JC_Icon_RingBuilder_small.png";
import DiamondLink from "../../assets/images/JC_Icon_DiamondLink_small.png";
import GemStoneLink from "../../assets/images/JC_Icon_GemStoneLink_small.png";
import PendantBuilder from "../../assets/images/JC_Icon_PendantBuilder_small.png";
import StudBuilder from "../../assets/images/JC_Icon_StudBuilder_small.png";
import JewelryLink from "../../assets/images/Jc_Icon_JewelryLink_small.png";
import { useTranslation } from "react-i18next";
import {
  setChecklinkHeaderMenuData,
  setOpenKeyHeaderMenuData,
  setSelectSideMenu,
} from "../../actions/headerMenu/headerMenu";
import MasterLink from "../../assets/images/JC_Icon_MasterLink_small.png";
import CoreUpgradeModal from "./CoreUpgradeModal";

const AllApps = () => {
  const { t } = useTranslation();
  const headerDetials = useSelector((state) => state.headerMenuReducer);
  const loginDetials = useSelector((state) => state.loginReducer);
  const dispatch = useDispatch();

  const [upgradeModalVisible, setUpgradeModalVisible] = useState(false);
  const [selectedApp, setSelectedApp] = useState("");

  // Read permissions straight from Redux on every render — same pattern
  // sidemenu.js uses for its Gemstone Link nav entry — instead of a local
  // state copy synced only at mount, which could go stale relative to the
  // sidebar (e.g. right after impersonation handoff or redux-persist rehydration).
  const applicationPermisstionResponse =
    headerDetials?.applicationPermisstionResponse || {};

  // Permissions are otherwise only fetched once, at login/impersonation
  // start, and persisted — so a long-open tab (e.g. an impersonation session
  // started before an admin toggles a dealer's permission) never sees the
  // change. Re-fetch fresh every time this page is landed on, and dispatch
  // into the same headerMenuReducer slice sidemenu.js reads from, so both
  // the tile grid and the left-nav entry pick up current DB state together.
  const dealerId = loginDetials?.loginDetials?.responseData?.dealerId;
  useEffect(() => {
    if (!dealerId) return;
    adminToolsService
      .GetAllMenuDtlsByPermission({ dealerId: dealerId.toString() })
      .then((response) => {
        if (response.data.message === "Success") {
          dispatch(setHeaderMenuData(response.data.responseData));
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealerId]);

  // Partner (non-Core) accounts are blocked from every app tile.
  const loginData = loginDetials?.loginDetials?.responseData || {};
  const isPartner =
    headerDetials?.isPartner ??
    headerDetials?.applicationPermisstionResponse?.isPartner ??
    loginData.isPartner ??
    false;
  const isJewelCloudCore =
    headerDetials?.isJewelCloudCore ??
    headerDetials?.applicationPermisstionResponse?.isJewelCloudCore ??
    loginData.isJewelCloudCore ??
    false;
  const blockApps = isPartner && !isJewelCloudCore;

  const handleOpenSideMenu = (Menu) => {
    var MenuData = [`${Menu}`];

    dispatch(setOpenKeyHeaderMenuData(MenuData));
    if (Menu == "Diamond Link") {
      dispatch(setSelectSideMenu(["applicationPreviewDiamondLink"]));
    }
    if (Menu == "Ring Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewRingBuilder"]));
    }
    if (Menu == "Stud Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewStudBuilder"]));
    }
    if (Menu == "Pendant Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewPedantBuilder"]));
    }
     if (Menu == "Gemstone Link") {
      dispatch(setSelectSideMenu(["applicationPreviewGemStoneLink"]));
    }
    if ((Menu = "Website Sync")) {
      dispatch(setChecklinkHeaderMenuData("My Catalog"));
      dispatch(setSelectSideMenu(["SyncHistory"]));
    }
  };

  const tiles = [
    {
      colClass: "col-md-3 offset-1",
      img: DiamondLink,
      permKey: "diamondLink",
      to: "/applicationPreviewDiamondLink",
      menu: "Diamond Link",
      title: "Diamond Link",
    },
    {
      colClass: "col-md-3 ",
      img: RingBuilder,
      permKey: "ringBuilder",
      to: "/applicationPreviewRingBuilder",
      menu: "Ring Builder",
      title: "Ring Builder",
    },
    {
      colClass: "col-md-3 ",
      img: PendantBuilder,
      permKey: "pendantBuilder",
      to: "/applicationPreviewPedantBuilder",
      menu: "Pendant Builder",
      title: "Pendant Builder",
    },
    {
      colClass: "col-md-3 offset-1 ",
      img: StudBuilder,
      permKey: "studBuilder",
      to: "/applicationPreviewStudBuilder",
      menu: "Stud Builder",
      title: "Stud Builder",
    },
    {
      colClass: "col-md-3",
      img: MasterLink,
      permKey: "masterLink",
      to: "/MasterLinkApplicationPreview",
      menu: "Master Link",
      title: "Master Link",
    },
    {
      colClass: "col-md-3",
      img: JewelryLink,
      permKey: "jewelryLink",
      to: "/myvendors",
      menu: "Jewelry Link",
      title: "Jewelry Link",
      alt: "jewelryLink",
      // Exempt from the partner block — partner accounts keep JewelryLink
      // (still subject to its own permission flag).
      alwaysEnabled: true,
    },
    // Ticket #1793 — gated by applicationPermisstionResponse.gemstoneLink,
    // now populated from the App Activation Control "Gemstone Link" box.
    {
      colClass: "col-md-3 offset-1",
      img: GemStoneLink,
      permKey: "gemstoneLink",
      to: "/applicationPreviewGemStoneLink",
      menu: "Gemstone Link",
      title: "Gemstone Link",
    },
  ];

  // A tile is blocked by the partner gate unless it is explicitly exempt.
  const isTileBlocked = (tile) => blockApps && !tile.alwaysEnabled;

  // Ticket #1793 — match sidemenu.js's fail-closed check (`|| false`): a
  // missing/undefined permission key must disable the tile too, not just an
  // explicit `false`, otherwise the tile and the left-menu entry disagree.
  const isTileDisabled = (tile) =>
    isTileBlocked(tile) || !applicationPermisstionResponse[tile.permKey];

  const handleTileClick = (e, tile) => {
    if (isTileBlocked(tile)) {
      e.preventDefault();
      setSelectedApp(tile.title);
      setUpgradeModalVisible(true);
      return;
    }
    if (!applicationPermisstionResponse[tile.permKey]) {
      e.preventDefault();
      return;
    }
    handleOpenSideMenu(tile.menu);
  };

  const renderTile = (tile) => {
    const disabled = isTileDisabled(tile);
    return (
      <div className={tile.colClass} key={tile.permKey}>
        <div className="apps__block">
          <NavLink
            title={
              isTileBlocked(tile)
                ? t("Available to JewelCloud Core members only")
                : disabled
                ? `${tile.title} Not Access`
                : tile.title
            }
            to={disabled ? "#" : tile.to}
            onClick={(e) => handleTileClick(e, tile)}
            style={{ display: "inline-block" }}
          >
            <img
              alt={tile.alt || tile.title}
              src={tile.img}
              width="150"
              className={disabled ? "any-disable" : "app-image"}
              style={{
                cursor: disabled ? "not-allowed" : "pointer",
              }}
            />
          </NavLink>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="form__fields magento__mapping allapps__section p-5">
        <div className="row m-5">{tiles.slice(0, 3).map(renderTile)}</div>
        <div className="row m-5">{tiles.slice(3).map(renderTile)}</div>
      </div>
      <CoreUpgradeModal
        visible={upgradeModalVisible}
        onClose={() => setUpgradeModalVisible(false)}
        appName={selectedApp}
      />
    </React.Fragment>
  );
};

export default AllApps;
